export const PRODUCT_STATUS_WORKING = 0;
export const PRODUCT_STATUS_REVIEW = 1;
export const PRODUCT_STATUS_APPROVED = 2;
export const PRODUCT_STATUS_ARCHIVED = 3;
export const PRODUCT_STATUS_IMPORTED = 4;
export const PRODUCT_STATUS_IMPORTED_ACCEPTED = 5;
export const PRODUCT_STATUS_EXPORTED = 6;
export const PRODUCT_STATUS_REVISION = 7;
export const PRODUCT_STATUS_PUBLISHED = 8;
export const PRODUCT_STATUS_PUBLISHED_REVISION = 9;
export const PRODUCT_STATUS_UNPUBLISHED = 10;
